// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1-IC2","alert":"SettungsInbox_alert__1a6qN"};